<template>
  <div class="main-panel">
    <duka-modal
      v-if="modalOpen"
      @close="() => { return false }"
      style="display:block"
      :modalSize="'default'"
    >
      <span slot="head" style="padding-top:10px">Activate your account</span>
      <div slot="body">
        <div class="w-100 text-center">
          <img
            :src="dukaURL+'assets/sent.png'"
            alt
            style="width:100px; height:100px; margin:0 auto;"
            class="img img-responsive align-self-center rounded-circle mb-2"
          />

          <h3>
            <b>Please confirm your email</b>
          </h3>
          <h5>
            We sent a confirmation link to
            <b>{{ loggedUser.email }}.</b>
            <br />Please go to your inbox and click the confirmation link to continue
          </h5>
          <hr />
          <h5>
            Don't get an email?
            <a href="javascript:void(0)">Resend</a> or
            <a href="javascript:void(0)">Sign up with a different email</a>
          </h5>

          <h5>
            Already confirmed?
            <a href="javascript:void(0)">Refresh now</a>
          </h5>
        </div>
      </div>
    </duka-modal>

    <div class="content-wrapper" v-if="resultFound">
      <div class="row">
        <div class="col-12">
          <div class="d-lg-flex">
            <h3 class="font-weight-bold mb-4 mr-5 text-center">Welcome to your Dashboard</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomerAccount",
  data: () => ({
    user: {},
    loggedUser: {},
    resultFound: false
  }),
  created() {
    this.loadCurrentUser();
  },
  methods: {
    loadCurrentUser() {
      this.$store
        .dispatch("dukaGetRequest", "customer/get-current-member")
        .then(response => {
          this.resultFound = true;
          this.user = response.data.user_details;
          this.loggedUser = response.data.user;
          if (!Number(response.data.user.active)) {
            this.toggleModal();
          }
        });
    },
    loadCustomerBalance() {
      this.$store
        .dispatch("dukaGetRequest", "customer/get-customer-balance")
        .then(response => {
          this.resultFound = true;
          console.log(response.data);
        });
    }
  }
};
</script>
